import { render, staticRenderFns } from "./ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao.vue?vue&type=template&id=94277530&scoped=true"
import script from "./ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=94277530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94277530",
  null
  
)

export default component.exports